import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import SharedDateCalendar from './SharedDateCalendar';
import TimelineDayStatusMarkers from './TimelineDayStatusMarkers';
import { buildCalendarDayStatusMap, getCalendarDayStatus } from '../Timeline/utils/calendarDayStatus';
import { getCalendarDateKey } from '../../utils/calendarDateKey';

const TimelineCalendarDay = (props) => {
  const {
    day,
    outsideCurrentMonth,
    selected,
    today,
    dayStatusMap = new Map(),
    ...other
  } = props;

  const dayKey = getCalendarDateKey(day);
  const status = dayKey ? getCalendarDayStatus(dayStatusMap.get(dayKey) || {}) : getCalendarDayStatus();
  const isEmphasized = Boolean(selected || today);

  return (
    <Box sx={{ position: 'relative', overflow: 'visible', display: 'inline-flex' }}>
      <PickersDay
        {...other}
        day={day}
        outsideCurrentMonth={outsideCurrentMonth}
        selected={selected}
        today={today}
        sx={{
          position: 'relative',
          zIndex: 1,
          '&.Mui-selected': {
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            '&:hover': {
              bgcolor: 'primary.dark',
            },
          },
          '&.MuiPickersDay-today': {
            borderColor: 'primary.main',
            backgroundColor: 'transparent',
          },
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          bottom: isEmphasized ? 8 : 4,
          zIndex: 4,
          pointerEvents: 'none',
        }}
      >
        <TimelineDayStatusMarkers
          hasLogs={status.hasLogs}
          hasIncident={status.hasIncident}
          selected={isEmphasized}
          size="sm"
        />
      </Box>
    </Box>
  );
};

const TimelineDateCalendar = ({
  value,
  onChange,
  entries = [],
  activityDateKeys = [],
  allowFuture: _allowFuture = false,
  disableFuture: _disableFuture = true,
  disablePast = false,
  minDate,
  maxDate,
  sx,
  slots,
  slotProps,
  ...rest
}) => {
  const dayStatusMap = useMemo(
    () => buildCalendarDayStatusMap(entries, activityDateKeys),
    [activityDateKeys, entries]
  );
  const today = useMemo(() => new Date(), []);

  return (
    <SharedDateCalendar
      value={value}
      onChange={onChange}
      allowFuture={false}
      disableFuture={true}
      disablePast={disablePast}
      minDate={minDate}
      maxDate={maxDate || today}
      slots={{
        day: TimelineCalendarDay,
        ...slots,
      }}
      slotProps={{
        day: {
          dayStatusMap,
          ...(slotProps?.day || {}),
        },
        ...slotProps,
      }}
      sx={sx}
      {...rest}
    />
  );
};

export default TimelineDateCalendar;
